<template>
  <div class="contact-us">
    <div class="container">
      <div class="main-banner">
        <img
          src="@/assets/img/contactus-banner.jpg"
          alt=""
          class="banner-img"
        />
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <img src="@/assets/img/icon10.png" alt="" class="img" />
          <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
          <el-breadcrumb-item>Contact Us</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="row" style="margin: 40px 0">
        <div class="col-xs-12 col-sm-4 left hidden-xs wow fadeInLeft">
          <img src="@/assets/img/contactus01.jpg" alt="" />
        </div>
        <div class="col-xs-12 col-sm-8 wow fadeInRight">
          <div class="products-title">Contact Information</div>
          <ul class="icon">
            <li>
              <img
                src="@/assets/img/icon10.png"
                alt="address"
                title="address"
              /><span
                >Avenida Benito Juarez Sur sin nunero, Colonia centro. Texcoco Estado de México.C.P. 56100</span
              >
            </li>
            <li>
              <img
                src="@/assets/img/icon05.png"
                alt="email"
                title="email"
              /><span>info@fawcamionmexico.com</span>
            </li>
            <li>
              <img
                src="@/assets/img/icon08.png"
                alt="mobile phone"
                title="mobile phone"
              /><span>5955961886</span>
            </li>
            <li>
              <img
                src="@/assets/img/icon07.png"
                alt="WhatsApp"
                title="WhatsApp"
              /><span>5951226144</span>
            </li>
          </ul>
          <div class="row">
            <div class="col-xs-12 col-sm-12">
              <div class="clearfix message-icon">
                <div class="message-item">
                  <div class="icon">
                    <img src="@/assets/img/icon11.png" alt="" /><span
                      >Whatsapp</span
                    >
                    <div class="icon-hover">
                      <img src="@/assets/img/QRcode.png" alt="" />
                      <div class="increase"></div>
                    </div>
                  </div>
                </div>
                <div class="message-item">
                  <div class="icon">
                    <img src="@/assets/img/icon12.png" alt="" /><span>Facebook</span>
                    <div class="icon-hover">
                      <img src="@/assets/img/QRcode02.png" alt="" />
                      <div class="increase"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.contact-us {
  .left {
    img {
      width: 100%;
    }
  }
  .icon {
    li {
      margin: 0 0 15px 0;
      img {
        margin: 0 10px 0 0;
      }
    }
  }
  .message-icon {
    margin: 80px 0 0 0;
    .message-item {
      width: 30%;
      float: left;
      text-align: center;
      .icon {
        cursor: pointer;
        position: relative;
        width: fit-content;
        // margin: 0 auto;
        &:hover {
          .icon-hover {
            display: block;
          }
        }
        img {
          margin: 0 5px 0 0;
        }
        .icon-hover {
          display: block;
          position: absolute;
          left: 0px;
          bottom: 35px;
          border: 1px solid #cccccc;
          background-color: #fff;
          img {
            width: 64px;
            margin: 0px;
          }
          .increase {
            position: absolute;
            bottom: -13px;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 0;
            height: 0;
            border-width: 5px;
            border-color: #cccccc transparent transparent transparent;
            border-style: solid;
          }
        }
      }
    }
  }
}
</style>